var cilBolt = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M331.464,192l77-176H147.879l-81,288H187.9L148.37,496h58.851L475.456,192ZM192.779,464H187.63l39.529-192H109.121l63-224H359.536l-77,176H404.545Z' class='ci-primary'/>"];

export { cilBolt };

